import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { LogClass, Logger } from "src/app/logger";

@Component({
    selector: "step-permissions",
    templateUrl: "./permissions.component.html",
    styleUrls: [],
    standalone: false
})
@LogClass()
export class PermissionsComponent {
  private logger: Logger;

  @Input() public form: FormGroup;
}
